<script setup lang="ts">
useSeoMeta({
  title: 'Politique de Confidentialité - Ohmelec',
  robots: 'noindex, nofollow' // Bloque l'indexation par les moteurs de recherche
})
</script>

<template>
  <div class="pt-32 pb-24 sm:pt-40 sm:pb-32 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1 class="text-3xl sm:text-4xl font-bold tracking-tight mb-12">Politique de confidentialité</h1>

    <div class="space-y-10 text-dimmed leading-relaxed">
      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">Préambule</h2>
        <p>OHMELEC attache une grande importance au respect de la réglementation relative à la protection des données personnelles et notamment au Règlement Général sur la Protection des données (RGPD) et la loi informatique et liberté.</p>
        <p>Dans ce cadre, la présente Politique de confidentialité vous permettra de comprendre quelles données à caractère personnel vous concernant sont collectées par Ohmelec et à quoi elles sont destinées.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">Introduction</h2>
        <p>Cette politique décrit comment Ohmelec collecte, utilise et protège les informations personnelles des utilisateurs de son site vitrine. En utilisant ce Site, vous acceptez les pratiques décrites dans cette politique.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">Collecte des informations</h2>
        <p>Nous collectons des informations personnelles de manière volontaire lorsque vous interagissez avec notre Site, notamment lorsque vous :</p>
        <ul class="list-disc pl-5 space-y-2">
          <li>Remplissez un formulaire de contact</li>
          <li>Vous abonnez à notre newsletter</li>
          <li>Demandez des informations sur nos services</li>
        </ul>
        <p>Les informations collectées peuvent inclure votre nom, adresse e-mail, numéro de téléphone et autres données que vous fournissez volontairement.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">Utilisation des informations</h2>
        <p>Les informations que nous recueillons sont utilisées pour :</p>
        <ul class="list-disc pl-5 space-y-2">
          <li>Répondre à vos demandes et fournir des informations sur nos services</li>
          <li>Améliorer notre site web et nos offres</li>
          <li>Vous envoyer des communications marketing si vous y avez consenti</li>
        </ul>
        <p>Nous ne partageons pas vos informations avec des tiers, sauf si cela est nécessaire pour répondre à vos demandes ou si la loi l'exige.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">Protection des informations</h2>
        <p>Nous prenons des mesures techniques et organisationnelles raisonnables pour protéger vos informations personnelles contre la perte, l'accès non autorisé, la modification ou la divulgation.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">Droits des utilisateurs</h2>
        <p>Conformément à la règlementation, vous disposez de droits sur vos données personnelles :</p>
        <ul class="list-disc pl-5 space-y-2">
          <li>Droit d’accès, de rectification et de suppression (droit à l’oubli)</li>
          <li>Droit de limitation et d’opposition au traitement</li>
          <li>Droit à la portabilité des données</li>
        </ul>
        <p class="mt-4 p-4 rounded-xl border border-default bg-muted/20">
          Pour exercer ces droits, veuillez nous contacter à :
          <a href="mailto:contact@migl-consulting.fr" class="text-primary hover:underline">contact@migl-consulting.fr</a>
          ou
          <a href="mailto:contact@ohmelec.net" class="text-primary hover:underline">contact@ohmelec.net</a>.
        </p>
      </section>
    </div>
  </div>
</template>
